module.exports = __webpack_public_path__ + "img/logo_gcjk.80511665.png";